
























































import {IDENTITY_SERVICE_INSTANCE} from '@/services/identity.service';
import {Prop} from 'vue-property-decorator';
import Vue from 'vue';
import Component from 'vue-class-component';
import AmetrasTextFieldTemplate from '@/fields/text/AmetrasTextFieldTemplate.vue';
import {USER_SERVICE_INSTANCE} from '@/services/user.service';
import AmetrasFormularWrapper from '@/views/AmetrasFormularWrapper.vue';
import {DisguiseBusinessExceptionWrapper} from '@/exception/disguise-business-exception-wrapper';
import {ROUTER_SERVICE} from '@/services/router.service';
import {NAVI_SERVICE_INSTANCE} from '@/services/navi.service';

@Component({
  components: {AmetrasFormularWrapper, AmetrasTextFieldTemplate}
})
export default class LoginTemplate extends Vue {

  @Prop() redirectTo!: string;

  valid: boolean = false;
  passwordVisible: boolean = false;
  login: string = '';
  password: string = '';
  loading: boolean = false;

  loginRules = [(value: string) => {
    if (!value || value.trim().length === 0) {
      return 'Nutzername wird benötigt.';
    }
    return true;
  }];
  passwordRules = [(value: string) => {
    if (!value || value.trim().length === 0) {
      return 'Passwort wird benötigt.';
    }
    return true;
  }];

  $refs!: {
    form: AmetrasFormularWrapper
  };

  doLogin(login: string, password: string) {
    if (this.$refs.form.validate() && !this.loading) {
      this.loading = true;
      IDENTITY_SERVICE_INSTANCE.createSession(login, password).then(() => {
        NAVI_SERVICE_INSTANCE.clearNaviCache();
        ROUTER_SERVICE.resetProtectedRoutes();
        // prefetch the user details, so that the user details are directly preloaded.
        USER_SERVICE_INSTANCE.loadUserDetails().then((userInfo) => {
          // set the user info to the vuex store
          this.$store.commit('setUserInfo', {userInfo: userInfo.data});

          let redirectToParam: string = '';
          if (!Array.isArray(this.$route.query.redirectTo)) {
            redirectToParam = this.$route.query.redirectTo;
          }
          if (!redirectToParam) {
            redirectToParam = '/welcome';
          } else if (redirectToParam.indexOf('/') !== 0) {
            redirectToParam = '/' + redirectToParam;
          }
          this.$router.push(redirectToParam).then(() => {
            this.loading = false;
          }, () => {
            this.loading = false;
          });
        }, (error) => {
          if (!(error instanceof DisguiseBusinessExceptionWrapper)) {
            this.$store.commit('showSnack', {
              message: 'Fehler beim Laden der Nutzerinformationen',
              color: 'error'
            });
          }
          this.loading = false;
        });
      }, (error) => {
        let statusMessage;
        switch (error.response.status) {
          case 503:
            statusMessage = 'Identity Service ist nicht erreichbar';
            break;
          default:
            statusMessage = 'Ungültige Logindaten';
            break;
        }
        this.loading = false;
        alert(statusMessage);
      });
    }
  }
}
